import axios from "axios";
import { BASE_URL } from "../constants/Endpoints";

export async function fetchAppConfig() {
  return axios.get(`${BASE_URL}/appconfig/config.json`);
}
